import { createFileRoute } from "@tanstack/react-router";
import { overviewSearchSchema } from "./-lib/search-schema";



export const Route = createFileRoute("/_protected/attendance/overview/")({
  head: () => ({
    meta: [{ title: "考勤总览 · imiker CRM" }],
  }),
  validateSearch: overviewSearchSchema
});
